import React from "react";
export default function AgencyStaffDashboard() {
  return <h1>Agency Staff Dashboard</h1>;
}
